import React, {Component} from "react";
import Checkbox from "./checkbox";

class MultiSelectCheckbox extends Component {

    getCheckboxes = () => {
        const {
            itemList,
            valueProperty,
            textProperty,
            value,
            handleCheckboxChange
        } = this.props;

        return (
            itemList.map(item => {

                let checked = false;
                if (value && value[item[valueProperty]] && value[item[valueProperty]]["checked"] === true)
                    checked = true;

                return (
                    <div className="form-check" key={item[valueProperty]}>
                        <Checkbox
                            label={item[textProperty]}
                            checked={checked}
                            handleCheckboxChange={handleCheckboxChange}
                            name={item[valueProperty]}
                            id={item[valueProperty]}
                        />
                    </div>
                );
            })
        )
    }

    render = () => {

        const {
            itemList,
            itemsMap,
            valueProperty,
            textProperty,
            name,
            label,
            error,
            help,
            handleItemSelect,
            value,
            nullable,
            enterValue,
            ...rest
        } = this.props;

        return (
            <div className="form-group">
                <label htmlFor={name}>{label}</label>
                <div
                    className="checkbox-container"
                >
                    {this.getCheckboxes()}
                </div>

                {help && (
                    <small id={`${name}Help`} className="form-text text-muted">
                        {help}
                    </small>
                )}
                {error && <div className="alert alert-danger">{error}</div>}
            </div>
        );

    }

}

MultiSelectCheckbox
    .defaultProps = {
    valueProperty: "dbId",
    textProperty: "name",
    nullable: true,
    enterValue: false
};

export default MultiSelectCheckbox;
